<style scoped>  

  @media only screen and (max-width: 360px) {
    .search-input {
      max-width: 80% !important;
    }
  }

  @media only screen and (min-width: 361px) {
    .search-input {
      max-width: 85% !important;
    }
  }

</style>

<template>

  <div>

    <div class="ui large breadcrumb">
      <div class="bold section">{{ title }}</div>
    </div>

    <bookmark-button :label="title" />

    <div class="ui divider"></div>

    <div class="ui grid">      
      <div class="ten wide computer sixteen wide tablet sixteen wide mobile column">
        <button class="ui blue button" @click="$refs.formModal.create()">
          <i class="plus icon"></i> Novo Animal
        </button>
      </div>
      <div class="six wide computer sixteen wide tablet sixteen wide mobile column">
        <div class="ui basic right aligned segment no-padding no-margin">
          <div class="ui form">
            <div class="field">
              <search-input id="animals-search-input" ref="searchInput" class="search-input" @onSearch="search" />
              <button class="ui icon button m-l-10" @click="$refs.filterModal.show()">
                <i class="filter icon" :class="{ red: !!$store.state.pages.filters.animals }"></i>
              </button>
            </div>
          </div>    
        </div> 
      </div>
    </div>

    <data-table id="animals-dtbl" ref="dtbl" :service="service" :attributes="attributes" :fields="fields" @onRowClick="onShowAnimal" />

    <form-modal ref="formModal" @onSave="refresh" @onRemove="refresh" 
      @onShowPictures="onShowPictures" @onShowOwner="onShowOwner" />
    
    <filter-modal ref="filterModal" @onApply="filter" @onRemove="clearFilter" />

    <pictures-modal ref="picturesModal" />

    <owner-modal ref="ownerModal" @onSave="refresh" @onShowAnimals="onShowAnimals" />

  </div>

</template>

<script>
  
  import moment from "@/utils/moment"
  import AnimalService from "@/services/animal-service"
  import FormModal from "./form-modal"
  import FilterModal from "./filter"
  import PicturesModal from "./pictures-modal"
  import OwnerModal from "@/pages/entries/owners/form-modal"
  import { gridPage, onlySimavet } from "@/mixins"

  export default {    

    name: "AnimalsPage",

    mixins: [gridPage, onlySimavet],

    data() {
      return {        
        title: "Animais",
        service: new AnimalService(),
        attributes: ["id", "name", "raceId", "sex", "birthDate", "ownerId", "dead"],
        fields: [          
          { prop: "name", label: "Nome", render: this.renderName },
          { prop: "race.name", model: "Race", label: "Raça", render: this.renderRace },
          { prop: "sex", label: "Sexo", render: this.renderSex },
          { prop: "birthDate", label: "Idade", render: this.renderAge },
          { prop: "owner.name", model: "Owner", label: "Tutor" },
        ],
      }
    },

    components: {
      FormModal,
      FilterModal,
      PicturesModal,
      OwnerModal,
    },

    methods: {

      renderName(animal) {

        const deadIcon = animal.dead ? '<i class="cross grey icon m-l-5"></i>' : ""

        return animal.name + deadIcon
      },

      renderRace(animal) {
        return animal.race.name + ` <span class="ui tiny label m-l-10">Espécie: ${animal.race.species.name}</span>`
      },

      renderSex(animal) {

        let label = ""

        if (animal.sex == "male") {
          label = '<i class="mars blue icon"></i> Macho'
        } else if (animal.sex == "female") {
          label = '<i class="venus pink icon"></i> Fêmea'
        } else {
          label = '<i class="question circle grey icon"></i> Indefinido'
        }

        return label
      },

      renderAge(animal) {
        return moment.formatAge(animal.birthDate)
      },

      onShowAnimal(data) {
        this.$refs.formModal.update({ animalId: data.row.id })
      },

      onShowPictures(animalId) {
        this.$refs.picturesModal.show(animalId)
      },

      onShowOwner(owner) {
        this.$refs.ownerModal.update(owner)
      },

      onShowAnimals(owner) {
        this.$router.push(`/entries/owners/${owner.id}/animals`)
      },
    },
  }

</script>
